import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyBRUGMQD2ItErIW7itagBSeL_tvD0lQo7Q",
  authDomain: "prognos-48733.firebaseapp.com",
  databaseURL: "https://armtrain-cd7c6-default-rtdb.firebaseio.com",
  projectId: "prognos-48733",
  storageBucket: "prognos-48733.firebasestorage.app",
  messagingSenderId: "1663812359",
  appId: "1:1663812359:web:3443cc8fd648fe84fe7ba2",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth();
export const storage = getStorage();
export const db = getFirestore();
export const analytics =
  typeof window !== "undefined" ? getAnalytics(app) : null;
